import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "29",
  height: "21",
  viewBox: "0 0 29 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreIcon',
  setup(__props) {

const color = computed(() => {
  return window.config.BRAND === 'kuebler' ? '#DE2A2A' : '#0077BB'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M4.38575 0.0697188C4.14064 0.177329 3.88955 0.482224 3.8477 0.721357C3.82976 0.828968 3.81781 2.28768 3.82976 3.97357C3.8477 6.95676 3.85368 7.03448 3.97324 7.19589C4.2064 7.51275 4.39771 7.6084 4.77434 7.6084C5.15098 7.6084 5.34228 7.51275 5.57544 7.19589C5.695 7.03448 5.70098 6.95078 5.71892 4.46977L5.73685 1.90507L8.30156 1.88713C10.7826 1.8692 10.8663 1.86322 11.0277 1.74365C11.3445 1.5105 11.4402 1.31919 11.4402 0.942556C11.4402 0.565921 11.3445 0.374614 11.0277 0.141459C10.8663 0.015914 10.7885 0.015914 7.71568 0.00395727C5.18685 -0.00799942 4.52923 0.00395727 4.38575 0.0697188Z",
      fill: _unref(color)
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M17.7787 0.0697188C17.2167 0.314831 17.0374 1.08006 17.4319 1.54637C17.7309 1.89909 17.7488 1.89909 20.463 1.89909H22.944L22.9619 4.46379C22.9798 6.95078 22.9858 7.03448 23.1054 7.19589C23.3385 7.51275 23.5298 7.6084 23.9065 7.6084C24.2831 7.6084 24.4744 7.51275 24.7076 7.19589C24.8331 7.03448 24.8331 6.96872 24.8331 3.81216C24.8331 0.655596 24.8331 0.589834 24.7076 0.428419C24.6418 0.338744 24.5103 0.207221 24.4206 0.141459C24.2592 0.015914 24.1815 0.015914 21.1086 0.00395727C18.5798 -0.00799942 17.9222 0.00395727 17.7787 0.0697188Z",
      fill: _unref(color)
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M0.56128 9.6353C0.160732 9.80867 -0.066445 10.269 0.0172516 10.7174C0.0710567 10.9984 0.369973 11.3272 0.638998 11.4049C0.794435 11.4527 5.04503 11.4647 14.4729 11.4527L28.0855 11.4348L28.2469 11.3092C28.5638 11.0761 28.6594 10.8848 28.6594 10.5081C28.6594 10.1315 28.5638 9.9402 28.2469 9.70704L28.0855 9.5815L14.4131 9.56954C3.13794 9.55758 0.710738 9.56954 0.56128 9.6353Z",
      fill: _unref(color)
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M4.38575 13.4613C4.14064 13.5689 3.88955 13.8738 3.8477 14.113C3.82976 14.2206 3.81781 15.6793 3.82976 17.3652C3.8477 20.3484 3.85368 20.4261 3.97324 20.5875C4.03901 20.6772 4.17053 20.8087 4.2602 20.8745C4.42162 21 4.48738 21 7.64394 21C10.8005 21 10.8663 21 11.0277 20.8745C11.3445 20.6413 11.4402 20.45 11.4402 20.0734C11.4402 19.6967 11.3445 19.5054 11.0277 19.2723C10.8663 19.1527 10.7826 19.1467 8.30156 19.1288L5.73685 19.1108L5.71892 16.5461C5.70098 14.0651 5.695 13.9814 5.57544 13.82C5.50968 13.7303 5.38413 13.5988 5.30043 13.539C5.10315 13.3896 4.62488 13.3477 4.38575 13.4613Z",
      fill: _unref(color)
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M23.517 13.4613C23.2958 13.5629 23.0985 13.7722 23.0148 13.9934C22.973 14.101 22.9491 15.0276 22.9491 16.6358V19.1108L20.3844 19.1288C17.8974 19.1467 17.8137 19.1527 17.6523 19.2723C17.3354 19.5054 17.2397 19.6967 17.2397 20.0734C17.2397 20.45 17.3354 20.6413 17.6523 20.8745C17.8137 21 17.8794 21 21.036 21C24.1925 21 24.2583 21 24.4197 20.8745C24.5094 20.8087 24.6409 20.6772 24.7067 20.5875C24.8322 20.4261 24.8322 20.3603 24.8322 17.2038C24.8322 14.0472 24.8322 13.9814 24.7067 13.82C24.6409 13.7303 24.5154 13.5988 24.4317 13.539C24.2284 13.3896 23.7561 13.3477 23.517 13.4613Z",
      fill: _unref(color)
    }, null, 8, _hoisted_6)
  ]))
}
}

})